export const EMAIL_SENT = 'EMAIL_SENT';
export const CALLER_CONNECTED = 'CALLER_CONNECTED';



// WEBPACK FOOTER //
// ./src/constants/p2a.js